// extracted by mini-css-extract-plugin
export default {"container":"SocialMedia_container__Fjpyj","iconCircle":"SocialMedia_iconCircle__Qm7Ki"};